import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCreated = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M6.76172 12C10.0754 12 12.7617 9.31371 12.7617 6C12.7617 2.68629 10.0754 0 6.76172 0C3.44801 0 0.761719 2.68629 0.761719 6C0.761719 9.31371 3.44801 12 6.76172 12ZM7.51172 3.75H6.01172V8.25H7.51172V3.75Z" fill="currentColor"/>
  </svg>
);
export default SvgCreated;
